<template>
  <div>
    <div class="sf-pad-v-2 sf-font-xl">{{ props.title }}</div>
    <SfTable
      :headers="headers"
      :rows="props.rows"
      :initial-sort-by="initialSortBy"
      :sticky-header="true"
    >
      <template
        #header="{ header, headerIndex, headerLabel, sortBy, sortDirection }"
      >
        <a class="sf-a sf-c-text" :data-testid="`sf-header-${headerIndex}`">
          {{ headerLabel }}
        </a>
        <i class="fa" :class="sortingArrow(header.id, sortBy, sortDirection)" />
        <AccountTableHeaderBadge v-if="headerIndex === 1" />
      </template>

      <template #row="{ id, rowData }">
        <AccountTableItem
          :item="rowData"
          :item-id="rowData.id"
          :focused="groupListStore.focusedDropdown === id"
        />
      </template>
    </SfTable>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SfTable from '@app/shared/vue/components/sf-table/index.vue'
import AccountTableItem from './account-table-item.vue'
import { useGroupList } from '../store/group-list'
import type { AccountTableRow } from '../shared-types'
import { tableSortDirections } from '@app/shared/vue/components/sf-table/constants'
import AccountTableHeaderBadge from './account-table-header-badge.vue'

interface Props {
  rows: Array<AccountTableRow>
  title: string
}

const props = defineProps<Props>()

const groupListStore = useGroupList()
const headers = computed<
  Array<{
    id: keyof AccountTableRow
    label?: string
    width?: string
  }>
>(() => {
  return [
    {
      id: 'status',
      label: ' ',
      width: '35px',
    },
    {
      id: 'mappedAccountNumber',
      label: window.I18n.t('account_mapping_list.table_headers.mapped_name'),
      width: '42%',
    },
    {
      id: 'number',
      label: window.I18n.t('account_mapping_list.table_headers.import_name'),
      width: '42%',
    },
    {
      id: 'sortableBalance',
      label: window.I18n.t('account_mapping_list.table_headers.balance'),
      width: '6%',
    },
    {
      id: 'mappedAccountType',
      label: window.I18n.t('account_mapping_list.table_headers.account_type'),
      width: 'auto',
    },
  ]
})

const initialSortBy = computed(() => {
  return headers.value.find((h) => h.id === 'number') || ''
})

const sortingArrow = function (
  headerId: string,
  sortBy: string | { id: string },
  sortDirection: string
) {
  const sortById = typeof sortBy === 'string' ? sortBy : sortBy.id
  const currentSort = headerId === sortById

  const caretClassBySortDirection =
    sortDirection === tableSortDirections.DESC ? 'fa-caret-down' : 'fa-caret-up'

  const caretClass = currentSort ? caretClassBySortDirection : 'fa-caret-down'

  const colorClass = currentSort ? 'sf-c-primary' : 'sf-c-text-lighter'

  return [caretClass, colorClass]
}
</script>
